/**
 * Whether `el` can scroll horizontally (content wider than the visible box).
 *
 * @param {Element|null|undefined} el
 * @returns {boolean}
 */
export function computeHorizontalOverflow(el) {
  if (!el) return false;
  return el.scrollWidth > el.clientWidth;
}

/**
 * Invokes `onChange` when window size or `el`'s layout box may affect horizontal overflow.
 * Does not call `onChange` immediately; pair with {@link computeHorizontalOverflow} after mount.
 *
 * @param {Element} el
 * @param {() => void} onChange
 * @returns {() => void} Call to remove listeners and disconnect observers.
 */
export function subscribeHorizontalOverflow(el, onChange) {
  if (!el || typeof onChange !== 'function') {
    return () => {};
  }

  const notify = () => {
    onChange();
  };

  window.addEventListener('resize', notify);

  let resizeObserver = null;
  if (typeof ResizeObserver !== 'undefined') {
    resizeObserver = new ResizeObserver(notify);
    resizeObserver.observe(el);
  }

  return () => {
    window.removeEventListener('resize', notify);
    if (resizeObserver) {
      resizeObserver.disconnect();
      resizeObserver = null;
    }
  };
}
